import PropTypes from 'prop-types';
import { Loader } from '@karma/components';
import Modal from 'components/templates/Modal/Modal';
import * as ALOOMA from 'consts/alooma';

const ModalKarmaEarnRedirectLoading = props => {
  const { sourcePage } = props;

  return (
    <Modal
      source={sourcePage}
      aloomaModalName={ALOOMA.MODAL_NAMES.KARMA_EARN_REDIRECT_LOADING}
      aloomaModalType={ALOOMA.MODAL_TYPES.POPUP}
      sendPageView={false}
      showClose={false}
    >
      <Loader width="100%" height="auto" />
    </Modal>
  );
};

ModalKarmaEarnRedirectLoading.propTypes = {
  sourcePage: PropTypes.string.isRequired,
};

export default ModalKarmaEarnRedirectLoading;
